import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-checker-itfacility-rejgrid',
  templateUrl: './checker-itfacility-rejgrid.component.html',
  styleUrls: ['./checker-itfacility-rejgrid.component.scss']
})
export class CheckerItfacilityRejgridComponent implements OnInit {

constructor(public appservice:AppService,public router:Router) { }
verifyemployee(id:any){
  this.appservice.checkeritfacilitygridedit=id;
  this.router.navigate(['/home/checker-itfacility-rejform']);
}

  ngOnInit(): void {
    this.appservice.checkerITfacilityRejectgrid();

  }

}



